import React from "react";
import FormField from "../../Components/FormField/FormField";
import PasswordToggle from "../../Components/FormField/PasswordToggle";
import PasswordStrengthMeter from "../Register/PasswordStrengthMeter";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";

function PasswordChange(props) {
  const state = props.state;

  const handlePassword = (e) => {
    let password = e.target.value
    props.handleStateChange("new_password", password)
    let passwordarray = []
    if (!password.match(".{8,}")) passwordarray.push("8 characters")
    if (!password.match("(?=.*?[0-9])")) passwordarray.push("1 digit")
    props.handleStateChange("check_password", passwordarray)
  }

  const togglePassword = (type) => {
    props.handleStateChange(`show_password_${type}`, !state[`show_password_${type}`]);
  }

  return (
    <>
      <FormField
        id="current_password"
        label="Current Password"
        type={state.show_password_current ? "text" : "password"}
        placeholder="Enter current password"
        onChange={props.handleFormFieldChange}
        required
      >
        <PasswordToggle onClick={() => togglePassword("current")} />
      </FormField>
      <FormField
        id="new_password"
        label="New Password"
        icon="lock"
        type={state.show_password_new ? "text" : "password"}
        placeholder="Enter New Password"
        value={state.new_password}
        onChange={handlePassword}
        header={
          state.check_password.length > 0
            ? state.check_password.length > 1
              ? " must contain " +
              state.check_password[0] +
              " including " +
              state.check_password[1]
              : " must contain " + state.check_password[0]
            : null
        }
      >
        <PasswordToggle onClick={() => togglePassword("new")} />
      </FormField>
      <PasswordStrengthMeter password={state.new_password} handleStateChange={props.handleStateChange} />
      <FormField
        id="confirm_password"
        label="Confirm New Password"
        icon="lock"
        type={state.show_password_confirm ? "text" : "password"}
        className={
          state.confirm_password !== "" && state.confirm_password !== state.new_password
            ? "error-form-control"
            : ""
        }
        placeholder="Re-enter Your New Password"
        value={state.confirm_password}
        onChange={props.handleFormFieldChange}
        required={state.new_password}
      >
        <PasswordToggle onClick={() => togglePassword("confirm")} />
      </FormField>
    </>
  )
}

export default PasswordChange;